import React from 'react'
import classNames from 'classnames'
import { TitleXS, TitleXXS } from '@/atoms/Text'
import { useViewableStoriesConfig } from '@/organisms/CollectibleSceneInfo/useViewableStoriesConfig'
import { useCollectiblesPlayerEngagement } from '@/organisms/CollectiblesPlayer/CollectiblesPlayerEngagement/CollectiblesPlayerEngagementContext'
import { useLocale } from '@/utils/LocaleUtil'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface MoreStoriesButtonProps {
  totalNumberOfStories?: number
  className?: string
}

export const MoreStoriesButton: React.FC<MoreStoriesButtonProps> = ({ totalNumberOfStories = 0 }) => {
  const { showUserStoriesList } = useCollectiblesPlayerEngagement()
  const { locale } = useLocale()
  const { t } = useTranslate('watch')

  const { remainingCount } = useViewableStoriesConfig(totalNumberOfStories)

  if (remainingCount === 0) return null

  const formattedCount = Intl.NumberFormat(locale, { notation: 'compact', compactDisplay: 'short' }).format(
    remainingCount,
  )

  return (
    <div
      onClick={showUserStoriesList}
      className={'flex h-full w-20 shrink-0 rounded-xl border border-core-gray-700 bg-core-gray-900'}
    >
      <div className={classNames('flex-grow-1 aspect-h-16 aspect-w-9')}>
        <div className="flex cursor-pointer flex-col items-center justify-center text-center">
          <Translate t={t} i18nKey="moreStoriesButton" values={{ formattedCount }}>
            <TitleXS color="white" weight="bold">
              +{{ formattedCount }}
              <br />
            </TitleXS>
            <TitleXXS>
              More <br /> Stories
            </TitleXXS>
          </Translate>
        </div>
      </div>
    </div>
  )
}
